<template>
  <slot
    :selected="bulkEdit.isSelected(props.item.id)"
    :select="() => bulkEdit.select(props.item.id)"
    :deselect="() => bulkEdit.deselect(props.item.id)"
    :toggle="() => bulkEdit.toggle(props.item.id)"
  />
</template>
<script
  setup
  lang="ts"
  generic="T extends Record<string, unknown> & { id: string }"
>
import { injectOrFail } from '@teachino/shared-util';
import { onMounted, onUnmounted, provide } from 'vue';
import { bulkEditInjectionKey, bulkEditItemInjectionKey } from './bulk-edit';

const bulkEdit = injectOrFail(
  bulkEditInjectionKey,
  'This component can only be used inside a BulkEditGroup',
);

const props = defineProps<{ item: T }>();
provide(bulkEditItemInjectionKey, props.item);

onMounted(() => bulkEdit.registerItem(props.item));
onUnmounted(() => bulkEdit.deregisterItem(props.item.id));
</script>
